var _ellipse, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.24,
    cx: 15,
    cy: 15,
    rx: 15,
    ry: 15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 15C26 21.0751 21.0751 26 15 26C8.92487 26 4 21.0751 4 15C4 8.92487 8.92487 4 15 4C21.0751 4 26 8.92487 26 15Z",
    stroke: "white",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1538_5739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.46 12.005C18.36 11.71 18.08 11.5 17.75 11.5H12.25C11.92 11.5 11.645 11.71 11.54 12.005L10.555 14.84C10.52 14.945 10.5 15.055 10.5 15.17V18.75C10.5 19.165 10.835 19.5 11.25 19.5C11.665 19.5 12 19.165 12 18.75V18.5H18V18.75C18 19.16 18.335 19.5 18.75 19.5C19.16 19.5 19.5 19.165 19.5 18.75V15.17C19.5 15.06 19.48 14.945 19.445 14.84L18.46 12.005ZM12.25 17C11.835 17 11.5 16.665 11.5 16.25C11.5 15.835 11.835 15.5 12.25 15.5C12.665 15.5 13 15.835 13 16.25C13 16.665 12.665 17 12.25 17ZM17.75 17C17.335 17 17 16.665 17 16.25C17 15.835 17.335 15.5 17.75 15.5C18.165 15.5 18.5 15.835 18.5 16.25C18.5 16.665 18.165 17 17.75 17ZM11.5 14.5L12.135 12.59C12.205 12.39 12.395 12.25 12.61 12.25H17.39C17.605 12.25 17.795 12.39 17.865 12.59L18.5 14.5H11.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1538_5739"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.493ddef2408ee0bb64e06471ed6c9a38.svg";
export { ForwardRef as ReactComponent };